import React, { Component } from 'react';
import DataTable from '../../../components/DataTable/index';
import PropTypes from 'prop-types';
import $ from 'jquery';
import { STATES } from '../../../services/constant/constant';
import { Filings } from '../services/Filings';

class FilingListGrid extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                title: 'Effective Date',
                data: 'effectiveDate'
            },
            {
                title: 'Expiration Date',
                data: 'expirationDate'
            },
            {
                title: 'State',
                data: 'stateId'
            },
            {
                title: 'Status',
                data: 'filingStatus'
            },
            {
                title: 'Permit Number',
                data: 'permitNumber'
            },
            {
                title: 'Review',
                data: null
            }
        ];
        this.columnFormat = [
            {
                targets: [0, 1],
                render: function(data, type, full) {
                    if (data) {
                        let date = new Date(data);
                        return date.toLocaleDateString('en-US');
                    }
                }
            },
            {
                targets: [2],
                render: function(data, type, full) {
                    if (data) {
                        return STATES[data].code;
                    }
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    td.title = STATES[cellData].name;
                }
            },
            {
                targets: [3],
                className: 'text-center',
                render: (data, type, full) => {
                    let filingStatusName = Filings.getFilingStatusName(data);
                    let isSalesReport = full.isSalesReport
                        ? ' (Sales)'
                        : '';
                    return filingStatusName + isSalesReport;
                }
            },
            {
                targets: [-1],
                width: '5%',
                className: 'text-center',
                render: function(data, type, full) {
                    return '<span class="label label-default" title="Review" style="cursor: pointer; font-size: 90%"><span class="glyphicon glyphicon-search"></span></button>';
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    let data = cellData;
                    $(td).css('max-width', '5px');
                    $(td).click(cellData => {
                        props.handleReviewButtonClick(data);
                    });
                }
            }
        ];

        if (props.handleButtonClick) {
            this.columns.push({
                title: props.buttonText,
                data: null
            });

            this.columnFormat.push({
                targets: [-1],
                width: '8%',
                className: 'text-center',
                render: function(data, type, full) {
                    return (
                        '<span class="label label-default" style="cursor: pointer; font-size: 90%">' +
                        props.buttonText +
                        '</span>'
                    );
                },
                createdCell: function(td, cellData, rowData, row, col) {
                    let data = cellData;
                    $(td).click(cellData => {
                        props.handleButtonClick(data);
                    });
                }
            });
        }
    }

    componentWillUnmount() {
        let { updateSelected } = this.props;
        updateSelected({});
    }
    render() {
        let { dataList, singleSelection, updateSelected } = this.props;
        return (
            <DataTable
                id="filingsListGrid"
                columns={this.columns}
                data={dataList}
                singleSelection={singleSelection}
                onSelectedItems={data => {
                    updateSelected(data[0]);
                }}
                columnFormat={this.columnFormat}
                rowFormat={(row, data, dataIndex) => {
                    if (singleSelection) {
                        $(row).css('cursor', 'pointer');
                    }
                }}
            />
        );
    }
}

FilingListGrid.propTypes = {
    dataList: PropTypes.array.isRequired,
    singleSelection: PropTypes.bool,
    updateSelected: PropTypes.func,
    handleButtonClick: PropTypes.func,
    buttonText: PropTypes.string
};

FilingListGrid.defaultProps = {
    singleSelection: false,
    updateSelected: () => {},
    buttonText: 'Review'
};

export default FilingListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/components/FilingListGrid.js